import { mebibyteToByte } from '@flex-packages/utils';

export type CandidateAttachmentFileType = 'pdf' | 'word' | 'excel' | 'unknown';

export const CANDIDATE_ATTACHMENT_MIME_TYPES_BY_FILE_TYPE: Record<
  Exclude<CandidateAttachmentFileType, 'unknown'>,
  string[]
> = {
  pdf: [
    'application/pdf',
    /**
     * https://flex-cv82520.slack.com/archives/C06EKU4BLSV/p1723519845581299?thread_ts=1723519800.215269&cid=C06EKU4BLSV
     */
    'application/haansoftpdf',
  ],
  word: [
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  ],
  excel: [
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ],
};

const candidateAttachmentRules = {
  allowedMimeTypes: Object.values(
    CANDIDATE_ATTACHMENT_MIME_TYPES_BY_FILE_TYPE
  ).flat(),
  maxFileSize: mebibyteToByte(100),
};

export { candidateAttachmentRules };
